import { render, staticRenderFns } from "./ResolutionMobile.vue?vue&type=template&id=3e6d5610&scoped=true&"
import script from "./ResolutionMobile.vue?vue&type=script&lang=ts&"
export * from "./ResolutionMobile.vue?vue&type=script&lang=ts&"
import style0 from "./ResolutionMobile.vue?vue&type=style&index=0&id=3e6d5610&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6d5610",
  null
  
)

export default component.exports